module.exports = __webpack_public_path__ + "img/diferenciadores-icon.35bc3f21.svg";